import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';
import { reactLocalStorage } from 'reactjs-localstorage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { store } from '../index'


const SuperAdminPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {

      reactLocalStorage.set('lastRoutePath', props.location.pathname)
      const { auth } = store.getState();
      if (auth.user && auth.role === 3) {
        return <Component {...props} />
      } else {
        return <Redirect to="/login" />
      }
    }}
  />
);

SuperAdminPrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.object
}

SuperAdminPrivateRoute.defaultProps = {
  location: null
}

export default SuperAdminPrivateRoute;



// WEBPACK FOOTER //
// ./src/routes/SuperAdminPrivateRoute.js